export default "__VITE_ASSET__8b3f8749__"